export const Languages = [
  { value: "EN", text: "English" },
  { value: "ES", text: "Español" },
];
